import { render, staticRenderFns } from "./DocsFolder.vue?vue&type=template&id=905e3a2c&scoped=true&"
import script from "./DocsFolder.vue?vue&type=script&lang=js&"
export * from "./DocsFolder.vue?vue&type=script&lang=js&"
import style0 from "./DocsFolder.vue?vue&type=style&index=0&id=905e3a2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "905e3a2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VDataTable,VSelect})
